<div class="tensorflow-test-container">
  <h2>Prueba de Modelo TensorFlow.js</h2>

  <div class="status-section">
    <h3>Estado del Modelo</h3>
    <div *ngIf="loading" class="loading">
      <p>Cargando...</p>
    </div>
    
    <div *ngIf="!loading && modelLoaded" class="success">
      <p>✓ Modelo cargado exitosamente</p>
    </div>

    <div *ngIf="error" class="error">
      <p>{{ error }}</p>
    </div>
  </div>

  <div *ngIf="modelInfo" class="model-info">
    <h3>Información del Modelo</h3>
    <div class="info-section">
      <h4>Inputs:</h4>
      <pre>{{ modelInfo.inputs | json }}</pre>
    </div>
    <div class="info-section">
      <h4>Outputs:</h4>
      <pre>{{ modelInfo.outputs | json }}</pre>
    </div>
  </div>

  <div *ngIf="modelLoaded" class="prediction-section">
    <h3>Realizar Predicción</h3>
    <p>Ingresa los datos de entrada. Para imágenes, usa el formato correcto según el shape del modelo.</p>
    
    <div class="input-examples">
      <h4>Ejemplos de formato:</h4>
      <ul>
        <li>Vector 1D: [1, 2, 3, 4]</li>
        <li>Matriz 2D: [[1, 2], [3, 4]]</li>
        <li>Imagen (con batch): [[[[0.5, 0.3, 0.2], [0.1, 0.9, 0.4]]]]</li>
      </ul>
    </div>
    
    <textarea 
      [(ngModel)]="inputData" 
      placeholder='Ejemplo: [[[1, 2, 3], [4, 5, 6]]]'
      rows="8"
      class="input-textarea">
    </textarea>

    <button 
      (click)="predict()" 
      [disabled]="loading || !inputData"
      class="predict-button">
      Predecir
    </button>

    <button 
      (click)="testWithRandomData()" 
      [disabled]="loading"
      class="predict-button random-button">
      Probar con datos aleatorios
    </button>

    <div *ngIf="predictionResult" class="result">
      <h4>Resultado:</h4>
      <pre>{{ predictionResult | json }}</pre>
    </div>
  </div>
</div>
